type Logger = (name: string, ...args: unknown[]) => void;

const USE_CALLS_NAME = "useCalls";

export const CallsLogger = {
  log: ((name: string, ...args: unknown[]) => {
    console.log(`[${USE_CALLS_NAME}][${name}][Log]:`, ...args);
  }) as Logger,
  info: ((name: string, ...args: unknown[]) => {
    console.info(`[${USE_CALLS_NAME}][${name}][Info]:`, ...args);
  }) as Logger,
  warn: ((name: string, ...args: unknown[]) => {
    console.warn(`[${USE_CALLS_NAME}][${name}][Warn]:`, ...args);
  }) as Logger,
  error: ((name: string, ...args: unknown[]) => {
    console.error(`[${USE_CALLS_NAME}][${name}][Error]:`, ...args);
  }) as Logger,
};
